export default __webpack_public_path__ + "static/media/assessment.95182c27.svg";